import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";

export const columns = [
  "Employee Name",
  "Phone Number",
  "Job Title",
  "ODP Enrolment Status",
];

export const DEFAULT_EMPLOYEES_TABLE_PAGE_LIMIT = 10;
export const DEFAULT_EMPLOYEES_TABLE_PAGINATION_PARAMS: IPaginationParams = {
  page: PAGE_ONE,
  limit: DEFAULT_EMPLOYEES_TABLE_PAGE_LIMIT,
};
